import * as Sortable from '@givebutter/primitives/sortable';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as DeleteRuleDialog from './DeleteRuleDialog';
import { QuickBooksRule } from 'api/quickBooks';
import * as DropdownMenu from 'components/dropdown-menu';
import { InlineError } from 'components/form/InlineError';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';

interface RuleItemProps {
    rule: QuickBooksRule;
}

const RuleItem = ({ rule }: RuleItemProps) => {
    const { accountId } = useCurrentAccount();

    return (
        <div className="flex flex-col gap-2">
            <Sortable.Card
                className={twMerge(
                    'flex items-center justify-between gap-4 rounded-lg py-3',
                    rule.invalid ? 'border-red-300' : '',
                )}
            >
                <Sortable.Grip />
                <div className="flex flex-col gap-1">
                    <p className="text-sm font-medium">{rule.name}</p>
                    <p className="text-xs text-gray-500">
                        <RuleMappingName value={rule.mapping.service_item?.name} />
                        <RuleMappingName value={rule.mapping.class?.name} />
                        <RuleMappingName value={rule.mapping.account?.name} />
                        {rule.do_not_sync ? 'Do not sync' : 'Sync'}
                    </p>
                </div>
                <DropdownMenu.Root>
                    <DropdownMenu.EllipsisTrigger aria-label={'Actions'} />
                    <DropdownMenu.Content>
                        <DropdownMenu.LinkItem
                            to={`/accounts/${accountId}/settings/integrations/quickbooks/configure/rules/${rule.id}/edit`}
                        >
                            Edit
                        </DropdownMenu.LinkItem>
                        <DeleteRuleDialog.Root rule={rule}>
                            <DeleteRuleDialog.Trigger asChild>
                                <DropdownMenu.Item
                                    onSelect={e => e.preventDefault()}
                                    className="text-red-500"
                                >
                                    <FontAwesomeIcon icon={faTrash} /> Delete
                                </DropdownMenu.Item>
                            </DeleteRuleDialog.Trigger>
                        </DeleteRuleDialog.Root>
                    </DropdownMenu.Content>
                </DropdownMenu.Root>
            </Sortable.Card>
            {rule.invalid && <InlineError message="There are issues with this mapping rule" />}
        </div>
    );
};

interface RuleMappingNameProps {
    value?: string;
}

const RuleMappingName = ({ value }: RuleMappingNameProps) => {
    if (!value) {
        return null;
    }

    return <span className="capitalize">{value} | </span>;
};

export { RuleItem };
